

export const BASE_GROUP_LINKS = {
	LINK_404: `/404`,
};